export default {
  good_day_title: "What do we mean?",
  good_day_content:
    '<div class="text-quote-text q-pl-xs"><i>&bull; To wish you a good <span class="text-lowercase">{time_of_day}</span> </i><br><i>&bull; That it is a good <span class="text-lowercase">{time_of_day}</span>, whether you want it or not</i><br><i>&bull; That we feel good this <span class="text-lowercase">{time_of_day}</span> </i><br><i>&bull; That it is a <span class="text-lowercase">{time_of_day}</span> to be good on</i></div>',
}
